const UiCarouselMultipleViewPropsOption = {
  delay: { type: Number, default: 500 },
  //* 过渡的间隔
  arrow: { type: String, default: "hover" },
  //* 切换箭头显示时期
  width: { type: [String, Number], default: "100%" },
  //* 轮播图宽度, 支持10px, 10vh, 10
  height: { type: [String, Number], default: "100%" }
  //* 轮播图高度, 支持10px, 10vh, 10
};
const UiCarouselMultipleViewEmits = {
  change: (_number) => true
};

export { UiCarouselMultipleViewEmits, UiCarouselMultipleViewPropsOption };
//# sourceMappingURL=index.mjs.map
